import { useEffect, useState } from "react";
import api, { formatTL, formatDateTime } from "../lib/api";
import { Card } from "./ui/card";
import { Link } from "react-router-dom";

// Müşteri kartı: sadakat puanı ve bu müşteride kullanılan kuponlar
export default function CustomerRewards({ customerId, jobs = [] }) {
  const [loy, setLoy] = useState(null);
  useEffect(() => { api.get(`/growth/loyalty/${customerId}`).then((r) => setLoy(r.data)).catch(() => setLoy(null)); }, [customerId]);
  const used = jobs.filter((j) => j.coupon_code);
  return (
    <div className="grid md:grid-cols-2 gap-3" data-testid="customer-rewards">
      <Card className="p-4 shadow-none border-slate-200">
        <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Sadakat puanı</div>
        <div className="text-3xl font-bold mt-1" data-testid="loyalty-balance">{loy ? loy.balance : "—"}</div>
        <div className="text-xs text-slate-500 mt-1">{loy ? `En az ${loy.min_redeem} puan kullanılabilir. Puan, servis kaydındaki İndirim kutusundan harcanır.` : "Sadakat modülü kapalı olabilir."}</div>
        <div className="mt-3 divide-y text-sm max-h-48 overflow-y-auto">
          {(loy?.history || []).map((h) => <div key={h.id} className="py-1.5 flex justify-between"><span>{h.note || h.kind}</span><b className={h.points < 0 ? "text-rose-600" : "text-emerald-600"}>{h.points > 0 ? "+" : ""}{h.points}</b></div>)}
          {loy && loy.history.length === 0 && <div className="py-2 text-slate-500">Henüz hareket yok.</div>}
        </div>
      </Card>
      <Card className="p-4 shadow-none border-slate-200">
        <div className="flex items-center justify-between"><div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Kullanılan kuponlar</div><Link to="/admin/coupons" className="text-xs text-blue-700 font-semibold">Kuponları yönet →</Link></div>
        <div className="mt-3 divide-y text-sm">
          {used.map((j) => <div key={j.id} className="py-1.5 flex justify-between gap-2"><span><b className="font-mono">{j.coupon_code}</b> <span className="text-slate-500">· {j.job_number}</span></span><span className="text-slate-600">-{formatTL(j.discount_amount || 0)} · {formatDateTime(j.completed_at || j.created_at)}</span></div>)}
          {used.length === 0 && <div className="py-2 text-slate-500">Bu müşteri henüz kupon kullanmadı. Kupon, servis kaydı detayındaki İndirim kutusundan uygulanır.</div>}
        </div>
      </Card>
    </div>
  );
}
